import CashFlowCalculator from './index';

const CashFlowCalculatorBlock = {
  Component: CashFlowCalculator,
  BlockRenderer: () => <CashFlowCalculator />,
  metadata: {
    name: 'rentals/cash-flow-calculator',
    title: 'Rental Cash Flow Calculator',
    description: '',
    icon: 'businessperson',
    keywords: ['cash flow', 'calculator', 'rentals'],
    supports: {
      customClassName: false,
      html: false,
    },
    category: 'more',
    attributes: {},
  },
};

export default CashFlowCalculatorBlock;
